"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledArrowTooltip = exports.StyledContentTooltip = exports.StyledTriggerSpan = exports.StyledTriggerTooltip = exports.StyledTooltip = void 0;
const RadixTooltip = __importStar(require("@radix-ui/react-tooltip"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledTooltip = (0, styled_components_1.default)(RadixTooltip.Root) ``;
exports.StyledTriggerTooltip = (0, styled_components_1.default)(RadixTooltip.Trigger) ``;
exports.StyledTriggerSpan = styled_components_1.default.span `
    display: inline-block;
`;
exports.StyledContentTooltip = (0, styled_components_1.default)(RadixTooltip.Content) `
    font-family: var(--ds-font-family);
    font-weight: 700;
    font-size: 0.875rem;
    background-color: var(--ds-color-night);
    color: var(--ds-color-white);
    border-radius: var(--ds-border-radius);
    padding: 0.25rem 0.5rem;
    box-shadow: 0 4px 8px 0 rgb(68 72 126 / 15%);
`;
exports.StyledArrowTooltip = (0, styled_components_1.default)(RadixTooltip.Arrow) `
    fill: var(--ds-color-night);
`;
//# sourceMappingURL=Tooltip.styles.js.map